function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.7027 18.9263H10.2996",
    stroke: "#D1D1D1",
    style: {
      stroke: "#D1D1D1",
      stroke: "color(display-p3 0.8201 0.8201 0.8201)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6513 1.66354L14.6129 1.75318L10.8991 10.3718H7.24933C6.3785 10.3718 5.5461 10.5511 4.79053 10.8712L7.03162 5.51822L7.08285 5.39016L7.17249 5.18526C7.1981 5.10842 7.22372 5.03158 7.26213 4.96755C8.93975 1.08726 10.8351 0.203625 14.6513 1.66354Z",
    stroke: "#D1D1D1",
    style: {
      stroke: "#D1D1D1",
      stroke: "color(display-p3 0.8201 0.8201 0.8201)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.554 10.6277C20.9777 10.4484 20.363 10.3716 19.7483 10.3716H10.8992L14.613 1.75297L14.6514 1.66333C14.8435 1.72736 15.0228 1.81701 15.2149 1.89384L18.0451 3.08482C19.6202 3.73794 20.7216 4.41667 21.3875 5.23627C21.5155 5.38995 21.618 5.53082 21.7076 5.6973C21.8229 5.87659 21.9125 6.05587 21.9638 6.24797C22.015 6.36322 22.0534 6.47848 22.079 6.58093C22.4248 7.65665 22.2199 8.9757 21.554 10.6277Z",
    stroke: "#D1D1D1",
    style: {
      stroke: "#D1D1D1",
      stroke: "color(display-p3 0.8201 0.8201 0.8201)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 16.6215V19.1187C25.9999 19.3749 25.9871 19.631 25.9743 19.8871C25.731 24.3565 23.2337 26.6104 18.4954 26.6104H8.50655C8.1992 26.6104 7.89185 26.5848 7.5973 26.5464C3.52492 26.2774 1.34786 24.1004 1.07892 20.028C1.04051 19.7334 1.01489 19.4261 1.01489 19.1187V16.6215C1.01489 14.0475 2.57726 11.832 4.80554 10.8715C5.57392 10.5514 6.39352 10.3721 7.26434 10.3721H19.7632C20.3907 10.3721 21.0054 10.4617 21.5689 10.6282C24.1174 11.4094 25.9999 13.7913 25.9999 16.6215Z",
    stroke: "#D1D1D1",
    style: {
      stroke: "#D1D1D1",
      stroke: "color(display-p3 0.8201 0.8201 0.8201)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03174 5.51807L4.79065 10.8711C2.56236 11.8315 1 14.047 1 16.6211V12.8689C1 9.23188 3.58686 6.1968 7.03174 5.51807Z",
    stroke: "#D1D1D1",
    style: {
      stroke: "#D1D1D1",
      stroke: "color(display-p3 0.8201 0.8201 0.8201)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9959 12.8684V16.6206C25.9959 13.8032 24.1262 11.4085 21.5649 10.6401C22.2309 8.97529 22.423 7.66905 22.1028 6.58052C22.0772 6.46527 22.0388 6.35001 21.9875 6.24756C24.3695 7.47696 25.9959 9.99979 25.9959 12.8684Z",
    stroke: "#D1D1D1",
    style: {
      stroke: "#D1D1D1",
      stroke: "color(display-p3 0.8201 0.8201 0.8201)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.ef5d7d46b071913319b328dee9c6bf72.svg";
export { ForwardRef as ReactComponent };